import React, { useEffect, useState } from 'react'
import { Row, Col,Container } from 'react-bootstrap';
import   '../../assets/styles/home.css'
import Footer from '../../components/footer/Footer'
import Navigation  from '../../components/navigation/Navigation'
import Banner from '../../components/banner/banner';
import CardStyle1 from '../../components/card-style-1/card-style-1'
import { UIUX } from '../../assets/images';
import AnnouncementBar from '../../components/announcement/AnnouncementBar';

const ResposibleAndEthicalAI = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const principles = [
    {title: "Human-centered"},
    {title: "Inclusive by Design"},
    {title: "Transparent Logs"},
    {title: "Accountable Actions"},
    {title: "Reversible Steps"},
    {title: "Human Approval"}
  ];
  const controls = [
    {title: "Allowlist Tools"},
    {title: "Policy Checks"},
    {title: "PII Redaction"},
    {title: "Version Pinning"},
    {title: "Audit Trails"},
    {title: "Rollback Plan"}
  ];
  return (
    <div>

      {/* <AnnouncementBar/> */}
      <Navigation  show={show} onClose={handleClose}  onShow ={handleShow}/>
      <Banner title="Responsible & Ethical AI" bg={UIUX}/>
      <Container>
        <div class="mt-75">
        <h1 class="main-title">Our Approach</h1>
          <p class="main-content m-16 pr-content">Human-centered, inclusive, transparent, and accountable AI governed end-to-end with guardrails you can audit.</p>
        </div>
      <div class="mt-75">
      <h1 class="main-title">Principles</h1>
      <p class="main-content m-16 pr-content"><strong>Human-centered:</strong> Agents assist people not replace judgment. We design for clarity, reversible actions, and human-in-the-loop approvals on any state-changing step.</p>
      <p class="main-content m-16 pr-content"><strong>Inclusive:</strong> We test across representative users and data to reduce bias. Accessibility and multilingual UX are first-class, not afterthoughts.</p>
      <p class="main-content m-16 pr-content"><strong>Transparent:</strong> Every decision is traceable version-pinned prompts/models, tool-call logs, and plain-English rationales for actions taken or proposed.</p>
      <p class="main-content m-16 pr-content"><strong>Accountable:</strong> Ownership, escalation paths, and audit trails are built-in. We document risks, run red-teaming, and publish limitations with mitigations.</p>
      <Row className='mt-50'>
              {principles.map((principle, index) => {
              return (
              <Col xs={12} sm={6} md={4} lg={4} key={index}>
              <CardStyle1 title={principle.title} />
              </Col>
              )
              })}
           </Row>
      </div>
      <div class="mt-75">
      <h1 class="main-title">Governance & Controls</h1>
      <p class="main-content m-16 pr-content"><strong>Lifecycle governance:</strong> Idea → Design → Build → Validate → Deploy → Monitor → Retire with entry/exit criteria, risk reviews, and sign-offs.</p>
      <p class="main-content m-16 pr-content"><strong>Safety guardrails:</strong> Allow-listed tools, granular permissions, policy checks, rate limits, jailbreak filtering, and rollback plans for automations.</p>
      <p class="main-content m-16 pr-content"><strong>Data privacy:</strong> No training on your data by default; PII redaction, tokenization where needed, encryption in transit/at rest, configurable retention windows.</p>
      <p class="main-content m-16 pr-content"><strong>Evaluation & bias:</strong> Offline eval sets + live A/B, robustness and drift checks, fairness metrics tracked over time, incident replay for root-cause analysis.</p>
      <p class="main-content m-16 pr-content"><strong>Security & compliance:</strong> SSO/OIDC, RBAC/least-privilege, secrets management, vulnerability scanning, change control; aligns to SOC 2 / ISO 27001, GDPR/DPDP readiness.</p>
      <p class="main-content m-16 pr-content"><strong>Admin visibility:</strong> Dashboards for lineage (prompt → context → tools → outputs), approval queues, exportable logs, and downloadable Responsible AI Charter & DPIA templates.</p>
      <Row className='mt-50'>
              {controls.map((control, index) => {
              return (
              <Col xs={12} sm={6} md={4} lg={4} key={index}>
              <CardStyle1 title={control.title} />
              </Col>
              )
              })}
           </Row>
      </div>
      </Container>




      <Footer />


      </div>

  )
}

export default ResposibleAndEthicalAI
